import { render, staticRenderFns } from "./ExcelTable.vue?vue&type=template&id=c082f91c&scoped=true&"
import script from "./ExcelTable.vue?vue&type=script&lang=js&"
export * from "./ExcelTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c082f91c",
  null
  
)

export default component.exports